import React from 'react';
import { Card, Row, Col, Typography, Divider } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import najamPortrait from '../../Assets/About/Committee/nsc-ncgsa.png';
import usamaPortrait from '../../Assets/About/Secretariat/secretariat-member-2.jpg';
import noumanPortrait from '../../Assets/About/Secretariat/secretariat-nouman.jpg';

const { Title, Paragraph } = Typography;

const leadership = [
  { name: 'Prof. Dr. Najam Abbas Naqvi', role: 'Chairman NCGSA', image: najamPortrait },
  { name: 'Mr. Usama Ahmad', role: 'Co-Ordinator NCGSA', image: usamaPortrait },
  { name: 'Mr. M. Nouman Shaikh', role: 'Senior Program Manager', image: noumanPortrait },
];

const officerPositions = [
  'Business Development Manager',
  'Research M&E Officer NCGSA',
  'Accounts and Audit Officer',
];

const SecretariatComponent = () => (
  <section className="secretariat-section">
    <div className="secretariat-inner">
      <header className="secretariat-header">
        <Title level={2} className="secretariat-title">NCGSA Secretariat</Title>
        <Divider className="ncgsa-divider" />
      </header>

      <Row gutter={[48, 36]} justify="center" align="stretch" className="secretariat-grid">
        {leadership.map((member) => (
          <Col xs={24} sm={12} lg={6} key={member.name} className="secretariat-column">
            <Card className="secretariat-card" cover={<img src={member.image} alt={`Portrait of ${member.name}`} className="secretariat-image" />}>
              <Title level={3} className="secretariat-name">{member.name}</Title>
              <Title level={4} className="secretariat-role">{member.role}</Title>
            </Card>
          </Col>
        ))}
        <Col xs={24} sm={12} lg={6} className="secretariat-column">
          <Card className="secretariat-card secretariat-vacancy-card" cover={<div className="secretariat-placeholder" aria-hidden="true"><UserOutlined /></div>}>
            <Title level={4} className="secretariat-position">
              {officerPositions[0]}
            </Title>
          </Card>
        </Col>
      </Row>

      <Row gutter={[48, 36]} justify="center" align="stretch" className="secretariat-grid secretariat-vacancies">
        {officerPositions.slice(1).map((role) => (
          <Col xs={24} sm={12} lg={6} key={role} className="secretariat-column">
            <Card className="secretariat-card secretariat-vacancy-card" cover={<div className="secretariat-placeholder" aria-hidden="true"><UserOutlined /></div>}>
              <Title level={4} className="secretariat-position">
                {role}
              </Title>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  </section>
);

export default SecretariatComponent;
